export default __webpack_public_path__ + "static/media/A1.7880c219.png";